/** 메뉴 데이터 소스 */
export const menuDataSource = [
    // 회사소개
    { isShow: true, menuId: 'MENU1000', parentMenuId: null, level: 0, title: '회사소개', rootPath: '/company/intro', backgroundClass: 'sub-visual1', isActive: false },
    { isShow: true, menuId: 'MENU1010', parentMenuId: 'MENU1000', level: 1, title: '소개', path: '/company/intro', backgroundClass: 'sub-visual1', isActive: false },
    { isShow: true, menuId: 'MENU1020', parentMenuId: 'MENU1000', level: 1, title: '인재상', path: '/company/talent', backgroundClass: 'sub-visual1', isActive: false },

    // 채용공고
    { isShow: true, menuId: 'MENU2000', parentMenuId: null, level: 0, title: '채용공고', rootPath: '/recruit/careers', backgroundClass: 'sub-visual2', isActive: false },
    { isShow: true, menuId: 'MENU2010', parentMenuId: 'MENU2000', level: 1, title: '채용공고', path: '/recruit/careers', backgroundClass: 'sub-visual2', isActive: false },
    { isShow: true, menuId: 'MENU2011', parentMenuId: 'MENU2010', level: 2, title: '채용공고 상세', path: '/recruit/careers-view', backgroundClass: 'sub-visual2', isActive: false },
    { isShow: true, menuId: 'MENU2020', parentMenuId: 'MENU2000', level: 1, title: '상시채용', path: '/recruit/always-recruite', backgroundClass: 'sub-visual2', isActive: false },
    { isShow: true, menuId: 'MENU2021', parentMenuId: 'MENU2020', level: 2, title: '상시채용 상세', path: '/recruit/always-recruite-view', backgroundClass: 'sub-visual2', isActive: false },
    { isShow: true, menuId: 'MENU2030', parentMenuId: 'MENU2000', level: 1, title: '공지사항', path: '/recruit/notice', backgroundClass: 'sub-visual2', isActive: false },
    { isShow: true, menuId: 'MENU2031', parentMenuId: 'MENU2030', level: 2, title: '공지사항 상세', path: '/recruit/notice-view', backgroundClass: 'sub-visual2', isActive: false },
    { isShow: true, menuId: 'MENU2040', parentMenuId: 'MENU2000', level: 1, title: '채용FAQ', path: '/recruit/faq', backgroundClass: 'sub-visual2', isActive: false },

    // 나의 지원정보
    { isShow: true, menuId: 'MENU3000', parentMenuId: null, level: 0, title: '나의 지원정보', rootPath: '/information/report', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3010', parentMenuId: 'MENU3000', level: 1, title: '지원서 조회/수정', path: '/information/report', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3011', parentMenuId: 'MENU3010', level: 2, title: '지원서 조회/수정', path: '/information/report-detail', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3020', parentMenuId: 'MENU3000', level: 1, title: '합격여부조회', path: '/information/confirm-notice', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3021', parentMenuId: 'MENU3020', level: 2, title: '실명인증', path: '/information/confirm-notice-detail', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3022', parentMenuId: 'MENU3020', level: 2, title: '합격여부조회', path: '/information/pass', backgroundClass: 'sub-visual3', isActive: false },

    { isShow: true, menuId: 'MENU3030', parentMenuId: 'MENU3010', level: 2, title: '지원서 조회', path: '/information/show-enroll', backgroundClass: 'sub-visual3', isActive: false },

    // 실명인증
    { isShow: true, menuId: 'MENU3031', parentMenuId: 'MENU3011', level: 2, title: '실명인증', path: '/recruit/apply', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3032', parentMenuId: 'MENU3031', level: 3, title: '이용동의', path: '/recruit/apply-edit', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3033', parentMenuId: 'MENU3011', level: 2, title: '지원서 조회/수정', path: '/recruit/enroll-application', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3034', parentMenuId: 'MENU3033', level: 3, title: '지원서 조회/수정', path: '/recruit/input-careers', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3038', parentMenuId: 'MENU3033', level: 2, title: '지원서 조회/수정', path: '/recruit/enroll-application2', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3035', parentMenuId: 'MENU3033', level: 3, title: '지원서 조회/수정', path: '/recruit/interview', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3036', parentMenuId: 'MENU3033', level: 3, title: '지원서 조회/수정', path: '/recruit/confirm-application', backgroundClass: 'sub-visual3', isActive: false },
    { isShow: true, menuId: 'MENU3037', parentMenuId: 'MENU3033', level: 3, title: '지원서 작성완료', path: '/recruit/welcome', backgroundClass: 'sub-visual3', isActive: false },

    // 이용안내
    { isShow: true, menuId: 'MENU4000', parentMenuId: null, level: 0, title: '이용안내', rootPath: '/guide/persnal-information', backgroundClass: 'sub-visual4', isActive: false },
    { isShow: true, menuId: 'MENU4010', parentMenuId: 'MENU4000', level: 1, title: '이메일주소 무단수집거부', path: '/guide/persnal-information', backgroundClass: 'sub-visual4', isActive: false },
];

/**
 * 메뉴관리 클래스
 */
class MenuManagement {

    /**
     * 생성자
     */
    constructor() { }

    /**
     * 메뉴목록 반환
     */
    getMenuItems() {

        // return menuDataSource.filter(menuInfo => menuInfo.isShow);

        const menuItems = [];

        const getChildMenuItems = menuInfo => {

            // 대상메뉴에 해당하는 자식메뉴 목록
            const childMenuItems = menuDataSource.filter(item => item.parentMenuId === menuInfo.menuId && item.isShow);

            // 자식메뉴 목록 결과
            const resultChildMenuItems = new Array();

            childMenuItems.forEach(childMenuInfo => {

                childMenuInfo.children = getChildMenuItems(childMenuInfo);
                resultChildMenuItems.push(childMenuInfo);
            });

            return resultChildMenuItems;
        }

        // 메뉴목록 가공 (트리형식으로)
        menuDataSource.filter(item => item.level === 0 && item.isShow).forEach(topMenuInfo => {

            topMenuInfo.children = getChildMenuItems(topMenuInfo);
            menuItems.push(topMenuInfo);
        });

        return menuItems;
    }

    /**
     * 메뉴 데이터 소스
     * 가공 되지않은 메뉴 정보 반환 
     * @returns {[{parentMenuId: null, level: number, menuId: string, rootPath: string, title: string, backgroundClass: string, isActive: boolean, isShow: boolean},{path: string, parentMenuId: string, level: number, menuId: string, title: string, backgroundClass: string, isActive: boolean, isShow: boolean},{path: string, parentMenuId: string, level: number, menuId: string, title: string, backgroundClass: string, isActive: boolean, isShow: boolean},{parentMenuId: null, level: number, menuId: string, rootPath: string, title: string, backgroundClass: string, isActive: boolean, isShow: boolean},{path: string, parentMenuId: string, level: number, menuId: string, title: string, backgroundClass: string, isActive: boolean, isShow: boolean},null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null]}
     */
    getMenuDataSource() {  return menuDataSource; }
}

export const menuManagement = new MenuManagement();